import { OptionalTruthyStringSchema } from 'notable-common';
import { z } from 'zod';
import { FlowDurationSchema } from '../../../duration/duration.js';
export const FlowAsynchronousExportJobNullableStringSchema = OptionalTruthyStringSchema.nullable();
export const FlowAsynchronousExportJobRequiredStringSchema = z.string().min(1);
export const FlowAsynchronousExportJobBaseSchema = z.object({
    timeout: FlowDurationSchema,
    v2: z.boolean().optional(),
});
export const FlowAsynchronousExportJobOptionalBaseEncounterParamsSchema = z.object({
    providerUserId: OptionalTruthyStringSchema,
    encounterEhrReferenceValue: OptionalTruthyStringSchema,
    encounterId: OptionalTruthyStringSchema,
    encounterStartTime: OptionalTruthyStringSchema,
    encounterEndPressedTimestamp: OptionalTruthyStringSchema,
});
export const FlowAsynchronousExportJobOptionalOrderParamsSchema = FlowAsynchronousExportJobOptionalBaseEncounterParamsSchema.extend({
    patientOrderId: OptionalTruthyStringSchema,
    patientOrderEhrScheduled: OptionalTruthyStringSchema,
    fin: OptionalTruthyStringSchema,
    ehrReferenceValue: OptionalTruthyStringSchema,
    patientEhrId: FlowAsynchronousExportJobRequiredStringSchema,
    ehrInformationId: OptionalTruthyStringSchema,
});
export const FlowAsynchronousExportJobOrderParamsSchema = FlowAsynchronousExportJobOptionalBaseEncounterParamsSchema.extend({
    patientOrderId: FlowAsynchronousExportJobRequiredStringSchema,
    patientOrderEhrScheduled: OptionalTruthyStringSchema,
    fin: OptionalTruthyStringSchema,
    ehrReferenceValue: OptionalTruthyStringSchema,
    patientEhrId: FlowAsynchronousExportJobRequiredStringSchema,
    ehrInformationId: FlowAsynchronousExportJobRequiredStringSchema,
});
export const FlowAsynchronousExportJobOptionalBasePatientOrderParamsSchema = z.object({
    patientOrderId: OptionalTruthyStringSchema,
});
export const FlowAsynchronousExportJobPatientParamsSchema = FlowAsynchronousExportJobOptionalBaseEncounterParamsSchema.extend(FlowAsynchronousExportJobOptionalBasePatientOrderParamsSchema.shape).extend({
    ehrInformationId: OptionalTruthyStringSchema,
    patientEhrId: FlowAsynchronousExportJobRequiredStringSchema,
    patientFhirId: OptionalTruthyStringSchema,
    patientFirstName: FlowAsynchronousExportJobRequiredStringSchema,
    patientLastName: FlowAsynchronousExportJobRequiredStringSchema,
    patientDateOfBirth: FlowAsynchronousExportJobRequiredStringSchema,
    patientPhoneNumber: OptionalTruthyStringSchema,
    patientSex: FlowAsynchronousExportJobRequiredStringSchema,
    existingPatientMailingAddress: OptionalTruthyStringSchema,
    athenaIdxMrn: OptionalTruthyStringSchema,
});
export const FlowAsynchronousExportJobPayorParamsSchema = z.object({
    payor: FlowAsynchronousExportJobNullableStringSchema,
    payorPlan: FlowAsynchronousExportJobNullableStringSchema,
    specialty: FlowAsynchronousExportJobNullableStringSchema,
    patient: z.object({
        firstName: FlowAsynchronousExportJobRequiredStringSchema,
        lastName: FlowAsynchronousExportJobRequiredStringSchema,
        dateOfBirth: FlowAsynchronousExportJobRequiredStringSchema,
    }),
    insurance: z
        .object({
        memberId: FlowAsynchronousExportJobNullableStringSchema,
    })
        .nullable()
        .optional()
        .default(null),
});
export var FlowAsynchronousExportJobKind;
(function (FlowAsynchronousExportJobKind) {
    FlowAsynchronousExportJobKind["ExportAuthorizationStatus"] = "EXPORT_AUTHORIZATION_STATUS";
    FlowAsynchronousExportJobKind["ExportAuthorizationStatusV2"] = "EXPORT_AUTHORIZATION_STATUS_V2";
    FlowAsynchronousExportJobKind["ExportAuthorizationSubmission"] = "EXPORT_AUTHORIZATION_SUBMISSION";
    FlowAsynchronousExportJobKind["ExportCareGapFindings"] = "EXPORT_CARE_GAP_FINDINGS";
    FlowAsynchronousExportJobKind["ExportFindingEvidence"] = "EXPORT_FINDING_EVIDENCE";
    FlowAsynchronousExportJobKind["ExportForms"] = "EXPORT_FORMS";
    FlowAsynchronousExportJobKind["ExportGeneralComment"] = "EXPORT_GENERAL_COMMENT";
    FlowAsynchronousExportJobKind["ExportHccFindings"] = "EXPORT_HCC_FINDINGS";
    FlowAsynchronousExportJobKind["ExportNoticeOfAdmissionStatus"] = "EXPORT_NOTICE_OF_ADMISSION_STATUS";
    FlowAsynchronousExportJobKind["ExportNoticeOfAdmission"] = "EXPORT_NOTICE_OF_ADMISSION";
    FlowAsynchronousExportJobKind["ExportPatientCareProviders"] = "EXPORT_PATIENT_CARE_PROVIDERS";
    FlowAsynchronousExportJobKind["ExportPatientInsuranceInformation"] = "EXPORT_PATIENT_INSURANCE_INFORMATION";
    FlowAsynchronousExportJobKind["ExportPrevisitPlanning"] = "EXPORT_PREVISIT_PLANNING";
    FlowAsynchronousExportJobKind["ExportReferralDocument"] = "EXPORT_REFERRAL_DOCUMENT";
    FlowAsynchronousExportJobKind["ExportReferralOrder"] = "EXPORT_REFERRAL_ORDER";
    FlowAsynchronousExportJobKind["ExportScheduledAppointment"] = "EXPORT_SCHEDULED_APPOINTMENT";
    FlowAsynchronousExportJobKind["ExportSocialHistory"] = "EXPORT_SOCIAL_HISTORY";
    FlowAsynchronousExportJobKind["ExtractMedicalNecessity"] = "EXTRACT_MEDICAL_NECESSITY";
    FlowAsynchronousExportJobKind["ExtractPatientInsurance"] = "EXTRACT_UPCOMING_PATIENT_INSURANCE";
    FlowAsynchronousExportJobKind["ExtractAuthorizationStatus"] = "EXTRACT_AUTHORIZATION_STATUS";
})(FlowAsynchronousExportJobKind || (FlowAsynchronousExportJobKind = {}));
//# sourceMappingURL=common.js.map